function getTrustedOrigins(currentOrigin: string): Set<string> {
  const origins = new Set([currentOrigin]);
  const { hostname } = new URL(currentOrigin);

  if (hostname === "swansonking.com" || hostname === "launch.swansonking.com") {
    origins.add("https://swansonking.com");
    origins.add("https://launch.swansonking.com");
  } else if (
    hostname === "swansonking.localhost" ||
    hostname === "launch.swansonking.localhost"
  ) {
    origins.add("https://swansonking.localhost");
    origins.add("https://launch.swansonking.localhost");
  }

  return origins;
}

export function getSafeAuthCallbackUrl(): string {
  if (typeof window === "undefined") {
    return "/";
  }

  const isWorkspace =
    window.location.pathname === "/workspace" ||
    window.location.pathname.startsWith("/workspace/");
  let publicOrigin = window.location.origin;
  if (publicOrigin === "https://launch.swansonking.com") publicOrigin = "https://swansonking.com";
  else if (publicOrigin === "https://launch.swansonking.localhost") publicOrigin = "https://swansonking.localhost";
  const fallback = isWorkspace ? new URL("/workspace", publicOrigin).toString() : "/";
  const candidate = new URLSearchParams(window.location.search).get(
    "callbackURL",
  );
  if (!candidate) {
    return fallback;
  }

  try {
    const isRelative = candidate.startsWith("/") && !candidate.startsWith("//");
    const url = new URL(candidate, window.location.origin);
    if (
      (!isRelative &&
        !getTrustedOrigins(window.location.origin).has(url.origin)) ||
      url.username ||
      url.password ||
      url.pathname.startsWith("/sign-in") ||
      url.pathname === "/workspace/sign-in"
    ) {
      return fallback;
    }
    if (isWorkspace) {
      return new URL(`${url.pathname}${url.search}${url.hash}`, publicOrigin).toString();
    }
    return isRelative
      ? `${url.pathname}${url.search}${url.hash}`
      : url.toString();
  } catch {
    return fallback;
  }
}
